import ApiService from '@Utils/apiService'
import * as Path from './apiRoutes'
import { formatAmount, parseAmount, formatDate } from '@Utils/formatters'
import { cloneDeep } from 'lodash'
import moment from 'moment'
// Import the action creators
import * as Actions from './actions'
import { error } from 'jquery'
import axios from 'axios'

export const getListCoA = () => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { CoAList: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()
    
    let sortModel = null
    let searchlist = {
        CompID: auth.credentials.companyId,
        coAID: appliedFilter.CoAID == '' ? 0 : appliedFilter.CoAID,
        ModuleID: appliedFilter.ModuleID,
        ModuleName: appliedFilter.ModuleName,
        Pagination: {
            Page: 0,
            PageSize: 10,
        },
        Sort: {
            field: 'CoAID',
            sort: 'desc'
        },
    }

    ApiService.get(Path.LIST, searchlist)
        .then((response) => {
            if (response) {
                const { data } = response
                dispatch(Actions.updateCoAList({
                    data: data.items,
                    totalCount: data.count,
                }))
            }
            // return response.data
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const fetchModuleDropDowns = (compid) => (dispatch) => {
    return ApiService.get(Path.MODULES_DDL, {company: compid})
        .then((response) => {
            const data = response.data.map(({ name, value }) => ({ name, value }));
            return data;
        })
        .catch((error) => {
            console.log(error);
            return [];
        });
}

export const fetchEmployeeSVDropDowns = (compid) => (dispatch) => {
    return ApiService.get(Path.EMPLOYEESV, {compID: compid})
        .then((response) => {
            const data = response.data.map(({ name, value }) => ({ name, value }));
            dispatch(Actions.fetchEmployeeSVDDLValues(data))
            return data;
        })
        .catch((error) => {
            console.log(error);
            return [];
        });
}


export const resetSearchResults = () => (dispatch) => {
    // reset filter
    dispatch(Actions.resetResults())
    // Update the list
    dispatch(getListCoA())
}

export const deleteCoA = (data) => (dispatch) => {
    dispatch(Actions.isLoading(true))

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update Success',
            content: 'Configuration successfully deleted.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.delete(Path.ROOT + '/' + data)
        .then((response) => {
            if (response) {
                let title = 'Delete Success'
                const { message } = response.data
                if (response.data.returnCode <= 0) {
                    title = 'Delete Failed'
            }
                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message,
                    confirmLabel: 'Ok',
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const updateCoA = (CoAID) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    const { CoAList: { updateValues } } = getState()

    let updatedData = cloneDeep(updateValues)
    updateValues.CoAID = CoAID

    let returnValue = {
        data: {},
        alertData: {
            show: false,
            title: 'Update success',
            content: 'Successfuly updated record.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.put(Path.ROOT + '/' + CoAID, updatedData)
        .then((response) => {
            if (response) {
                let title = 'Update Success'
                const message = 'Approver successfully updated.'
                let goBackToList = true
                
                if (response.data.returnCode <= 0) {
                    title = 'Update Failed'
                    goBackToList = false
                }

                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message,
                    confirmLabel: 'Ok',
                    goBackToListFlag: goBackToList,
                    onHide: () => {
                        dispatch(Actions.hideListAlert())
                        dispatch(resetSearchResults())
                    }
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
            dispatch(Actions.setListAlert(returnValue.alertData))
        })
}

//ERF LIST ACTIONS/ACTION OPERATIONS

export const changeRowsPerPage = (pageModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterRowsPerPage(pageModel))
    // Update list
    dispatch(getListERF())
}

export const changeSort = (sortModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterSort(sortModel))
    // Update list
    dispatch(getListERF())
}

export const applySearchFilters = (searchModel) => (dispatch) => {
    // Page will always be zero upon searching
    dispatch(Actions.changeFilterPage(0))

    // dispatch the search filters
    dispatch(Actions.applyFilters(searchModel))

    // get data from server and update results
    dispatch(getListCoA())
}

export const resetFilters = () => (dispatch, getState) => {
    dispatch(Actions.resetFilters())
    return new Promise((resolve, reject) => {
        const { CoAList: { searchFilter } } = getState()
        resolve(searchFilter)
    })
}